import type { FC } from 'react';

interface Props {
  message?: string;
}

const NotFound: FC<Props> = ({ message }) => (
  <div style={{ textAlign: 'center', padding: '2rem' }}>
    <h1>404 – Not Found</h1>
    <p>{message || 'The page you’re looking for doesn’t exist.'}</p>
    <a href="/template-studio-ui">Go to Builder</a>
  </div>
);

export default NotFound;
